import QBadge from 'quasar/src/components/badge/QBadge.js';
import Enumerable from "linq";
import { defineComponent, ref, watch } from "vue";
import { commonStore } from "~/store/CommonStore";
export default defineComponent({
    name: "MypageBadge",
    extends: {
        QBadge
    },
    props: {
        kbn: {
            type: Number,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        /** 設定項目２、３を使用する */
        useOptionValue2: {
            type: Boolean,
            default: false
        },
        /** 設定項目４、５を使用する */
        useOptionValue4: {
            type: Boolean,
            default: false
        },
        style: {
            type: String,
            default: ""
        }
    },
    setup: (props) => {
        QBadge.setup;
        // 汎用項目3を使用する場合（スタイル設定必須）
        let badgeClass = ref();
        // // 汎用項目2を使用する場合（ラベル設定必須）
        let badgeLabel = ref();
        // 汎用項目4にアイコンを設定してること前提
        let badgeIcon = ref();
        const initView = () => {
            let model = commonStore.badgeList.GetByHanyoKb(props.kbn);
            let hanyoData = Enumerable.from(model).firstOrDefault(x => x.value === props.id);
            if (props.useOptionValue2) {
                badgeClass.value = hanyoData?.option1;
            }
            else if (props.useOptionValue4) {
                badgeClass.value = hanyoData?.option3;
            }
            else {
                badgeClass.value = hanyoData?.option1;
            }
            if (props.useOptionValue2) {
                badgeLabel.value = hanyoData?.option2;
            }
            else if (props.useOptionValue4) {
                badgeLabel.value = hanyoData?.option4;
            }
            else {
                badgeLabel.value = hanyoData?.label ?? props.label;
            }
            badgeIcon.value = hanyoData?.option5;
        };
        initView();
        //propsの値に変更があった場合に値を更新する
        watch(props, () => {
            initView();
        });
        return {
            props,
            badgeClass,
            badgeIcon,
            badgeLabel
        };
    }
});
